import { render, staticRenderFns } from "./coursePlay.vue?vue&type=template&id=f55ca006&scoped=true"
import script from "./coursePlay.vue?vue&type=script&lang=js"
export * from "./coursePlay.vue?vue&type=script&lang=js"
import style0 from "./coursePlay.vue?vue&type=style&index=0&id=f55ca006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55ca006",
  null
  
)

export default component.exports